export default __webpack_public_path__ + "48e6e913078692985f926b68025ad973.mp3";